import Api from "./Api";
import Csrf from "./Csrf";

export default {

  jsonToQueryString(paramsObject) {

    return '?' + Object
    .keys(paramsObject)
    .filter(key => paramsObject[key] !== null && paramsObject[key] != 'null')
    .map(key => `${encodeURIComponent(key)}=${(paramsObject[key])}`)
    .join('&')


    /*
    return '?' + 
        Object.keys(json).map(function(key) {
          if(( json[key] != null )){
            return encodeURIComponent(key) + '=' +
                encodeURIComponent(json[key]);
          }
          return '';
        }).join('&');
        */
},

  async getOrders(locationid, filters) {
    await Csrf.getCookie();

    return Api.get("/locations/" + locationid + "/orders"+this.jsonToQueryString(filters));
  },


  async getReportHotel(locationid, filters) {
    await Csrf.getCookie();

    return Api.get("/locations/" + locationid + "/orders/reporthotel"+this.jsonToQueryString(filters));
  },

 
  async getStatusesTypes() {
    await Csrf.getCookie();

    return Api.get("/orders/statuses-types");
  },

  async update(id, orderid,  form) {
    await Csrf.getCookie();
    form._method = "PATCH";

    return Api.post("/locations/" + id + "/orders/" + orderid, form);
  },

  async create(id, form) {
    await Csrf.getCookie();
    form._method = "POST";

    return Api.post("/locations/" + id + "/orders", form);
  },


  async updateStatus(id, orderid, form) {
    await Csrf.getCookie();
    form._method = "PATCH";

    return Api.post("/locations/" + id + "/orders/" + orderid +"/status", form);
  },
  
};